import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Tbody.css';

const Tbody = ({ children, className, ...rest }) => (
  <tbody className={classNames('tbody', className)} {...rest} >
    { children }
  </tbody>
);

Tbody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Tbody;



// WEBPACK FOOTER //
// ./src/components/Tbody/Tbody.jsx